import React from 'react';
import { ReactComponent as BookingsIcon } from '../icons/bookings-icon.svg';
import { ReactComponent as MinutesIcon } from '../icons/minutes-icon.svg';
import { ReactComponent as PeopleIcon } from '../icons/people-icon.svg';
import { ReactComponent as ControlIcon } from '../icons/control-icon.svg';
import { ReactComponent as SendIcon } from '../icons/send-icon.svg';
import { Button, ThemeProvider } from '@mui/material';
import muiTheme from '../../theme/muiTheme';

const VenueRegistration = () => {
  const handleListVenueClick = () => {
    window.open('https://tally.so/r/n9gP7E', '_blank');
  };

  const features = [
    {
      icon: <BookingsIcon className='w-10 h-10' />,
      title: "More bookings, less admin",
      description: "You don't have to worry about manually answering those enquiries every time"
    },
    {
      icon: <MinutesIcon className='w-10 h-10' />,
      title: "List your venue in minutes",
      description: "Simple setup process with professional photography support"
    },
    {
      icon: <PeopleIcon className='w-10 h-10' />,
      title: "Reach & collaborate with event organisers",
      description: "Bring more customers to your venue through targeted partnerships."
    },
    {
      icon: <ControlIcon className='w-10 h-10' />,
      title: "Manage bookings in one place",
      description: "Increase revenue with smart pricing and real time availability of your space"
    }
  ];

  return (
    <section className='content-width mx-auto container-padding px-8 pb-32 lg:grid grid-cols-2 gap-12 items-end'>
      <div className='flex flex-col gap-12'>
        {/* Header Section */}
        <h2 className='text-4xl md:text-6xl font-medium leading-relaxed order-1 md:order-1 md:w-full lg:w-[115%]'>
            Transform your venue into a sought-after destination
          </h2>
        <p className='text-lg font-normal text-gray-500 order-3 md:order-2'>
            Connect with curated events and conscious brands seeking distinctive venues and grow your brand through curated exposure that align with your space's story.
          </p>

        {/* USP Section */}
        <div className='flex flex-col gap-10 order-5 md:order-3'>
          {features.map((feature, index) => (
            <div key={index} className='flex flex-row gap-4'>
              <div className=''>
                {feature.icon}
              </div>
              <div className='flex flex-col gap-2'>
                <h3 className='text-2xl font-medium'>{feature.title}</h3>
                <p className='text-lg font-normal text-gray-500'>{feature.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className='order-4 md:order-4 flex flex-col md:flex-row gap-4 items-center'>
          
        <ThemeProvider theme={muiTheme}>
          <Button 
                variant="contained"
                onClick={handleListVenueClick}
                className='flex flex-row gap-2 md:w-fit w-full items-center shadow-none'>
            <span>List your venue</span>
            <SendIcon />
          </Button>
          <Button variant='text'>
            Learn more
          </Button>
          </ThemeProvider>
        </div>

        {/* Illustration */}
        <div className='order-2 md:order-5 md:hidden block'>
          <img src="/Venues.svg" alt="Venue illustration" />
        </div>
      </div>
      
        {/* Illustration */}
        <div className='md:block hidden py-8'>
          <img src="/Venues.svg" alt="Venue illustration" />
        </div>

    </section>
  );
};

export default VenueRegistration;
